import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router";
import { UserGuideNavigation } from "./user-guide/-components/UserGuideNavigation";

export const Route = createFileRoute("/_auth/app/_app/help/user-guide")({
	component: RouteComponent,
});

function RouteComponent() {
	const location = useLocation();

	// Determine active section based on current route
	const getActiveSection = () => {
		const pathname = location.pathname;
		if (
			pathname === "/app/help/user-guide" ||
			pathname === "/app/help/user-guide/"
		) {
			return "overview";
		}
		if (pathname.includes("/establishments")) return "establishments";
		if (pathname.includes("/livestock")) return "livestock";
		if (pathname.includes("/grass-production")) return "grassProduction";
		if (pathname.includes("/equipment")) return "equipment";
		if (pathname.includes("/financial")) return "financial";
		if (pathname.includes("/planning")) return "planning";
		if (pathname.includes("/feasibility")) return "feasibility";
		if (pathname.includes("/marketplace")) return "marketplace";
		if (pathname.includes("/assistant")) return "assistant";
		return "overview"; // default
	};

	const activeSection = getActiveSection();

	return (
		<div className="flex flex-col md:flex-row h-full bg-base-200">
			{/* Side Navigation - hidden on mobile */}
			<div className="hidden md:block">
				<UserGuideNavigation activeSection={activeSection} />
			</div>

			{/* Main Content Area - always visible */}
			<div className="flex-1 overflow-auto">
				<Outlet />
			</div>
		</div>
	);
}
